import React, { useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
import classes from './statusIcons.css';
import { ContextMenuTrigger } from "react-contextmenu";

const isRuleFound = (row, isRah) => isRah && row && row.Coding[0] && row.Coding[0].CodingType === 'Rule';
function collect(props) {
  return props;
}

const rahSyncIcon = (row, isRah, isMatchLoading) => {
  const isRahSyncing = row.SyncState && (row.SyncState === 'Queued' || row.SyncState === 'InProgress');
  const isRahSyncError = row.SyncError || row.SyncState === 'Error';

  if (isRahSyncing || (isMatchLoading && !row.MatchId && !isRahSyncError && row.Coding.length === 0)) {
    return (
      <Tooltip disableFocusListener disableTouchListener title={<span className={classes.statusLabel}>Syncing to RAH</span>}>
        <i className="fa fa-sync fa-spin text-muted" style={{ color: '#ccc', padding: '0 5px' }}></i>
      </Tooltip>
    );
  }

  if (isRahSyncError) {
    return (
      <Tooltip disableFocusListener disableTouchListener title={<span className={classes.statusLabel}>{row.SyncError}</span>}>
        <i className="fas fa-exclamation-circle" style={{ color: '#ff0000', padding: '0 5px' }}></i>
      </Tooltip>
    );
  }

  if (row.Coding.length && !isRuleFound(row, isRah) && row.lockedDetails === 'QC' && row.SyncState === 'Completed') {
    return (
      <Tooltip disableFocusListener disableTouchListener title={<span className={classes.statusLabel}>Posted to RAH</span>}>
        <i className="fas fa-check-circle" style={{ padding: '0 5px' }}></i>
      </Tooltip>
    );
  }
  return null
}

// ({ showModal: true, loadModal: 'Rule', transaction: row }) , this.showRuleModalHandler(row)
const rulesIcon = (row, showRuleModal) => (
  row.Coding.length > 0 && row.Coding[0].CodingSource && <Tooltip disableFocusListener disableTouchListener title={<span className={classes.statusLabel}>Coded by rule{row.RuleName && ` (${row.RuleName})`}</span>}><i onClick={() => showRuleModal(row)} className="far fa-dot-circle" style={{ padding: '0 5px' }}></i></Tooltip>
);

const StatusIcons = ({ row, isRah, isR1, showRuleModal, showCommentsModal, matchLoadingList }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const isMatchLoading = matchLoadingList.includes(row.BankDataGUID);
  let contextTrigger = null;
  const toggleMenu = e => {
    if (contextTrigger) {
      contextTrigger.handleContextClick(e);
      setTooltipOpen(false);
    }
  };

  return (
    <div className={classes.statusColumn}>
      <Tooltip open={tooltipOpen} title={<span className={classes.statusLabel}>Actions</span>}><div className={classes.actions_icon} onMouseEnter={() => { setTooltipOpen(true) }} onMouseLeave={() => { setTooltipOpen(false) }}><ContextMenuTrigger id="TransactionContextMenu" collect={collect} row={row} ref={c => contextTrigger = c}><i onClick={toggleMenu} className={`fas fa-tasks ${classes.color_green}`}></i></ContextMenuTrigger></div></Tooltip>
      {(row.Comments > 0) && <Tooltip disableFocusListener disableTouchListener title={<span className={classes.statusLabel}>{row.Comments} comment{row.Comments > 1 ? 's' : ''} on this row</span>}><span className={`fa-stack fa-1x ${classes.commentsIcon}`} style={{ width: "20px", marginLeft: 5 }} onClick={() => showCommentsModal(row)}><i className={`fa fa-comment fa-stack-2x ${classes.comment_icon}`}></i><strong className={`fa-stack-1x ${classes.comment_value}`}>{row.Comments>9?'9+':row.Comments}</strong></span></Tooltip>}
      {(row.isSaving) && <i className="fa fa-sync fa-spin text-muted" style={{ color: '#ccc', padding: '0 5px' }}></i>}
      {row.IsTransferFlagged && <Tooltip disableFocusListener disableTouchListener title={<span className={classes.statusLabel}>Transfer Pending</span>}><i className="fas fa-sign-in-alt" style={{ padding: '0 5px' }}></i></Tooltip>}
      {row.TransferDate && <Tooltip disableFocusListener disableTouchListener title={<span className={classes.statusLabel}>{`Transfered : ${moment(row.TransferDate).format('D MMM YY')}`}</span>}><i className="fas fa-lock" style={{ padding: '0 5px' }}></i></Tooltip>}
      {row.Reconciled && <Tooltip disableFocusListener disableTouchListener title={<span className={classes.statusLabel}>Reconciled</span>}><i className="fas fa-lock" style={{ padding: '0 5px' }}></i></Tooltip>}
      {!isR1 && !isRuleFound(row, isRah) && rulesIcon(row, showRuleModal)}
      {(row.lockedDetails && !row.MatchId && row.lockedDetails !== 'QC') && <Tooltip disableFocusListener disableTouchListener title={<span className={classes.statusLabel}>{row.lockedDetails}</span>}><i className={(row.lockedDetails === 'Already coded' || row.lockedDetails === 'Transfer already coded') ? 'fas fa-copyright' : 'fas fa-ban'} style={{ padding: '0 5px' }}></i></Tooltip>}
      {(row.locked1) && <i className="fa fa-star"></i>}
      {(row.MatchId) && <Tooltip disableFocusListener disableTouchListener title={<span className={classes.statusLabel}>Matched in Fast Coding</span>}><i className="fas fa-fire" style={{ padding: '0 5px' }}></i></Tooltip>}
      {(row.lockedDetails === 'QC' && !isRah) && <Tooltip disableFocusListener disableTouchListener title={<span className={classes.statusLabel}>Coded in Fast Coding</span>}><i className='fas fa-check-circle' style={{ padding: '0 5px' }}></i></Tooltip>}
      {isRah && !row.isSaving && rahSyncIcon(row, isRah, isMatchLoading)}
    </div>
  )
};

export default StatusIcons;


// WEBPACK FOOTER //
// ./src/components/TransactionList/Columns/StatusIcons/statusIcons.js